<template>
  <div style="background: #fff">
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
        border-right: 1px solid #ebeef5;
      "
    >
      <span>{{ categoryLabel[category] }}</span>
      <div>
        <el-button type="text" @click="addCol" v-if="edit">添加折扣</el-button>
        <el-button type="text" @click="edit = !edit" v-if="!edit"
          >编辑</el-button
        >
        <el-button type="text" @click="save" v-else>保存</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      cell-class-name="table-cell"
      header-row-class-name="flow-th"
      :show-header="edit"
      border
      ref="table"
    >
      <el-table-column
        v-for="item in colList"
        :key="item"
        header-align="center"
        width="180"
      >
        <template slot="header" slot-scope="{ column, $index }">
          <i class="el-icon-remove add_btn" @click="delCol(column, $index)"></i>
        </template>
        <template slot-scope="{ row, $index }">
          <template v-if="!edit">
            <div class="text-center">
              {{ showVal(row[item], $index) }}
            </div>
          </template>
          <template v-else>
            <template v-if="$index == 0">
              <el-input
                v-model="row[item]"
                type="number"
                :min="0"
                :max="100"
                :placeholder="category == 1 ? '折扣' : '金额'"
              >
                <template slot="prepend">{{
                  category == 2 ? '>' : '<'
                }}</template>
                <template slot="append" v-if="category == 1">%</template>
              </el-input>
            </template>
            <el-select
              v-else
              style="width: 100%"
              v-model="row[item]"
              placeholder="审批角色"
            >
              <el-option
                v-for="item in roles"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {
  commodityOrderFlowSetList,
  createCommodityOrderFlowSet,
} from '@/service/getData'

export default {
  props: {
    category: {
      type: Number,
      default: 0,
    },
    departmentId: {
      type: Number,
      default: 0,
    },
    dealerRank: {
      type: Number,
      default: 0,
    },
    roles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      colList: [],
      index: 1,
      tableData: [],
      edit: false,
      categoryLabel: {
        1: '订单折扣（下单后改价审批）',
        2: '订单金额（下单总金额审批）',
        3: '底价金额（服务商品底价审批）',
      },
    }
  },
  beforeUpdate() {
    this.$nextTick(() => {
      //在数据加载完，重新渲染表格
      this.$refs['table'].doLayout()
    })
  },
  mounted() {
    // this.initTable()
  },
  created() {
    this.getData()
  },
  watch: {
    departmentId: 'getData',
  },
  methods: {
    showVal(val, index) {
      if (!val) {
        return '-'
      }

      if (index == 0) {
        if (this.category == 1) {
          val = '<' + val + '%'
        } else if (this.category == 2) {
          val = '>' + val
        } else if (this.category == 3) {
          val = '<' + val
        }
      } else if (index == 1) {
        if (this.roles.length > 0) {
          val = this.roles.filter((item) => item.id == val)[0].name
        }
      }
      return val
    },
    async getData() {
      let res = await commodityOrderFlowSetList({
        dealer_rank: this.dealerRank,
        category: this.category,
        department_id: this.departmentId,
      })

      if (res.code == 0) {
        this.initTable(res.data.list)
      }
    },
    initTable(list = []) {
      if (list.length == 0) {
        list.push({})
      }

      let data = [{}, {}]
      this.colList = []

      list.map((item, index) => {
        let indexString = `index${index + 1}`
        this.colList.push(indexString)
        data[0][indexString] = item.number
        data[1][indexString] = item.role_id
      })

      this.tableData = data
      this.index = this.colList.length + 1
      this.$refs['table'].doLayout()
    },
    // addRow() {
    //   let obj = {}
    //   this.colList.map((item) => {
    //     obj[item] = ''
    //   })
    //   this.tableData.push(obj)
    // },
    addCol() {
      let str = 'index' + this.index
      this.index++
      this.tableData.map((item) => {
        this.$set(item, str, '')
      })
      this.colList.push(str)
    },
    delCol(column, index) {
      this.colList.splice(index, 1)
      if (Object.keys(this.tableData[0]).length == 1) {
        this.addCol()
      }
    },
    async save() {
      var discounts = this.tableData[0]
      var roles = this.tableData[1]

      let data = {
        dealer_rank: this.dealerRank,
        department_id: this.departmentId,
        category: this.category,
        flows: [],
      }

      this.colList.map((item) => {
        if (discounts[item]) {
          data.flows.push({
            number: parseInt(discounts[item]),
            role_id: roles[item] ? parseInt(roles[item]) : 0,
            role_name: roles[item]
              ? this.roles.filter((it) => it.id == roles[item])[0].name
              : '',
            category: this.category,
            department_id: this.departmentId,
            dealer_rank: this.dealerRank,
          })
        }
      })

      let res = await createCommodityOrderFlowSet(data)
      if (res.code == 0) {
        this.initTable(res.data.list)
        this.edit = false
      }
    },
  },
}
</script>

<style scoped>
/* .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: transparent;
} */
.add_btn {
  text-align: center;
  font-size: 14px;
  color: #909399;
  cursor: pointer;
}
/deep/ .el-table th.gutter {
  display: table-cell !important;
  width: 10px !important;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 179px;
}
/deep/.table-cell {
  padding: 4px !important;
  /* border-right: 1px solid #ebeef5; */
}

/deep/.table-cell .cell {
  padding: 0 !important;
}
</style>
<style>
.el-table__fixed-right::before,
.el-table__fixed::before {
  height: 0px !important;
}
.flow-th th {
  padding: 0 !important;
}
</style>